import React, { useEffect, useRef, useState } from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Constants from '../Constants';
import { useAuth, has_permission } from '../AuthContext';

import wordmark from '../assets/menu-wordmark.png';

function NavBar() {
	const { token, is_superadmin, user_permissions, subscription_features } = useAuth();

	// Mirrors the side menu: a suspended subscription grants no features, so the parts of the app a
	// plan pays for are taken off both menus rather than one.
	const has_plan_features = is_superadmin || (subscription_features && subscription_features.length > 0);
	const navigate = useNavigate();
	const [expanded, set_expanded] = useState(false);
	const show_personas = is_superadmin || has_permission(user_permissions, 'persona_editor');
	const navbar_ref = useRef(null);

	useEffect(() => {
		if(!token) {
			// navigate('/login');
		}
	}, [token]);

	useEffect(() => {
		const handle_outside_click = (event) => {
			if(navbar_ref.current && !navbar_ref.current.contains(event.target)) {
				set_expanded(false);
			}
		};

		document.addEventListener('click', handle_outside_click);

		return () => {
			document.removeEventListener('click', handle_outside_click);
		};
	}, []);

	const handle_logout = () => {
		localStorage.removeItem(Constants.TOKEN_NAME);
		localStorage.removeItem(Constants.USER_ID);
		window.location.replace('/login');
	};

	// {is_superadmin && <Nav.Link as={Link} to="/admin/beta-test" onClick={() => set_expanded(false)}>Beta Test</Nav.Link>}

	return (
		<div ref={navbar_ref}>
			<Navbar expand="lg" fixed="top" className="navbar" expanded={expanded} onToggle={set_expanded}>
				<Container fluid className="navbar-container">
					<Navbar.Brand as={Link} to="/dashboard">
						<img src={wordmark} className="nabar-logo" alt="AI Call Trainer" />
					</Navbar.Brand>
					<Navbar.Toggle aria-controls="main-navbar" className="navbar-hamburger" />
					<Navbar.Collapse id="main-navbar">
						<Nav className="d-lg-none navbar-mobile-links">
							<Nav.Link as={Link} to="/dashboard" onClick={() => set_expanded(false)}>Dashboard</Nav.Link>
							{has_plan_features ? <Nav.Link as={Link} to="/calls" onClick={() => set_expanded(false)}>Calls</Nav.Link> : null}
							{has_plan_features ? <Nav.Link as={Link} to="/sales-profiles" onClick={() => set_expanded(false)}>Sales Profiles</Nav.Link> : null}
							{show_personas && <Nav.Link as={Link} to="/admin/personas" onClick={() => set_expanded(false)}>Prospect Personas</Nav.Link>}
							{is_superadmin && <Nav.Link as={Link} to="/agents" onClick={() => set_expanded(false)}>Agents</Nav.Link>}
							{is_superadmin && <Nav.Link as={Link} to="/admin/unit-economics" onClick={() => set_expanded(false)}>Unit Economics</Nav.Link>}
							{is_superadmin && <Nav.Link as={Link} to="/admin/cold-emailer" onClick={() => set_expanded(false)}>Cold Emailer</Nav.Link>}
							<Nav.Link as={Link} to="/account" onClick={() => set_expanded(false)}>Account</Nav.Link>
							<Nav.Link as={Link} to="/feedbackform" onClick={() => set_expanded(false)}>Feedback</Nav.Link>
							<Nav.Link as={Link} to="/help/introduction" onClick={() => set_expanded(false)}>Help</Nav.Link>
							{token && <Nav.Link onClick={handle_logout}>Log Out</Nav.Link>}
						</Nav>
					</Navbar.Collapse>
					{token && (
						<Nav.Link onClick={handle_logout} className="navbar-desktop-logout d-none d-lg-block">
							Log Out
						</Nav.Link>
					)}
				</Container>
			</Navbar>
		</div>
	);
}

export default NavBar;
